import { Getter, GetterTree } from 'vuex'

import { IAuthStore } from '@/features/auth/store'

import {
  GET_AUTH,
  GET_USER,
  GET_CUSTOMERS_LIST,
  GET_SELECTED_CUSTOMER,
  GET_CUSTOMER_NAME
} from '@/system/store/getter-types'

const getAuth: Getter<IAuthStore, any> = (state: IAuthStore) => {
  const { token, expiresAt } = state
  return { token, expiresAt }
}

const getUser: Getter<IAuthStore, any> = (state: IAuthStore) => {
  const { user } = state
  return user
}

const getCustomers: Getter<IAuthStore, any> = (state: IAuthStore) => {
  const { customers } = state
  return customers
}

const getSelectedCustomer: Getter<IAuthStore, any> = (state: IAuthStore) => {
  const { selectedCustomer } = state
  return selectedCustomer
}

const getCustomerName: Getter<IAuthStore, any> = (state: IAuthStore) => state.selectedCustomer ? state.selectedCustomer.name : ''

const getters: GetterTree<IAuthStore, any> = {
  [GET_AUTH]: getAuth,
  [GET_USER]: getUser,
  [GET_CUSTOMERS_LIST]: getCustomers,
  [GET_SELECTED_CUSTOMER]: getSelectedCustomer,
  [GET_CUSTOMER_NAME]: getCustomerName
}

export default getters
